import { render, staticRenderFns } from "./themeTab.vue?vue&type=template&id=0823f6ea&scoped=true&"
import script from "./themeTab.vue?vue&type=script&lang=js&"
export * from "./themeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0823f6ea",
  null
  
)

export default component.exports